import React from 'react';
import {
  AvatarImage,
  BadgeImage,
  BusinessAvatar,
  BusinessAvatarContainer,
  BusinessAvatarImage,
  BusinessDetails,
  BusinessHeader,
  BusinessInfo,
  BusinessName,
  BusinessTime,
  BusinessType,
  NewBadge,
  ReviewDate,
  ReviewHeader,
  ReviewItem,
  ReviewMeta,
  ReviewsContainer,
  ReviewText,
  Star,
  StarRating,
  UserAvatar,
  UserBadge,
  UserInfo,
  UserName,
  VerifiedBadge,
} from './styles';

import reviewsData from './reviews.json';

const Reviews: React.FC = () => {
  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, index) => (
      <Star key={index} filled={index < rating}>
        ★
      </Star>
    ));
  };

  return (
    <ReviewsContainer>
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '0 20px' }}>
        {reviewsData.map((review) => (
          <ReviewItem key={review.id}>
            <ReviewHeader>
              <UserAvatar hasPhoto={!!review.avatar}>
                {review.avatar ? (
                  <AvatarImage src={review.avatar} alt={review.name} />
                ) : (
                  review.initials
                )}
              </UserAvatar>
              <UserInfo>
                <UserName>{review.name}</UserName>
                <UserBadge>{review.reviewCount}</UserBadge>
                <ReviewMeta>
                  <StarRating>{renderStars(review.rating)}</StarRating>
                  <ReviewDate>{review.date}</ReviewDate>
                  {review.isNew && <NewBadge>Novo</NewBadge>}
                </ReviewMeta>
              </UserInfo>
            </ReviewHeader>

            <ReviewText>{review.text}</ReviewText>

            <BusinessInfo>
              <BusinessHeader>
                <BusinessAvatarContainer>
                  <BusinessAvatar hasImage={!!review.business.avatar}>
                    {review.business.avatar ? (
                      <BusinessAvatarImage
                        src={review.business.avatar}
                        alt="COI Prime"
                      />
                    ) : (
                      review.business.avatarText || review.business.avatar
                    )}
                  </BusinessAvatar>
                  {review.business.verified &&
                    review.business.verifiedBadgeImage && (
                      <VerifiedBadge>
                        <BadgeImage
                          src={review.business.verifiedBadgeImage}
                          alt="Selo de verificação"
                        />
                      </VerifiedBadge>
                    )}
                </BusinessAvatarContainer>
                <BusinessDetails>
                  <BusinessName>{review.business.name}</BusinessName>
                  <BusinessType>✓ {review.business.type}</BusinessType>
                  <BusinessTime>{review.business.time}</BusinessTime>
                </BusinessDetails>
              </BusinessHeader>
            </BusinessInfo>
          </ReviewItem>
        ))}
      </div>
    </ReviewsContainer>
  );
};

export default Reviews;
